import { $, $$ } from '../utils/dom.js';
import { Swiper } from '../vendor/vendor-globals.js';

const MOBILE_MQ = '(max-width: 767px)';

export function initTestimonials() {
  const disposers = $$('[data-component="testimonials"]').map((root) => setupTestimonials(root));

  return () => {
    disposers.forEach((dispose) => {
      dispose();
    });
  };
}

function setupTestimonials(root) {
  if (typeof Swiper !== 'function') {
    return () => { };
  }

  const mobile = window.matchMedia(MOBILE_MQ);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let swiper = null;

  const paginationEl = $('.testimonials__pagination', root);

  const create = () => {
    if (swiper) {
      return;
    }

    swiper = new Swiper(root, {
      wrapperClass: 'testimonials__list',
      slideClass: 'testimonials__item',
      slidesPerView: 1,
      spaceBetween: 40,
      speed: reduceMotion ? 0 : 600,
      watchOverflow: true,
      pagination: paginationEl
        ? {
            el: paginationEl,
            clickable: true,
            renderBullet(index, className) {
              return `<span class="${className}"><svg xmlns="http://www.w3.org/2000/svg" width="39" height="8" fill="none" aria-hidden="true"><path fill="currentColor" d="M0 2.333c.83.882 1.427 1.318 2.226 1.937 2.257 1.745 5.404 2.607 8.227 2.525 2.328-.06 4.584-.851 6.77-1.592.546-.182 1.093-.375 1.64-.558 2.822-.933 5.757-1.734 8.459-1.694 5.91.082 9.38 4.869 9.38 4.869l1.943-2.201s-4.634-4.392-11.323-4.31c-2.803.03-5.788 1.267-8.713 2.251-3.238 1.075-6.405 1.826-9.208 1.562C4.523 4.595 2.135 0 2.135 0L0 2.323z"/></svg></span>`;
            },
          }
        : false,
    });
  };

  const destroy = () => {
    if (!swiper) {
      return;
    }

    swiper.destroy(true, true);
    swiper = null;
  };

  const sync = () => {
    if (mobile.matches) {
      create();
    } else {
      destroy();
    }
  };

  mobile.addEventListener('change', sync);
  sync();

  return () => {
    mobile.removeEventListener('change', sync);
    destroy();
  };
}
